import React, { useMemo } from "react";
import { buildChildrensBookChapterSceneNavigationV1 } from "../utils/childrensBookChapterSceneNavigationV1";

// Navigation only. The existing Manuscript Plan owns selection and saving.
export default function ChildrensBookChapterSceneNavigatorV1({
  units = [], chapters = [], lang = "en", onOpenUnit,
}) {
  const isFR = String(lang).toLowerCase().startsWith("fr");
  const model = useMemo(() =>
    buildChildrensBookChapterSceneNavigationV1({ units, chapters }), [units, chapters]);
  const labels = isFR
    ? {title:"Parcourir le livre", front:"Pages liminaires", back:"Éléments de fin",
       unassigned:"Pages et doubles pages non attribuées", note:"Navigation uniquement : aucun chapitre ni aucune scène ne sont créés automatiquement.",
       invalid:"L’organisation des chapitres est invalide ; les pages sont affichées sans regroupement."}
    : {title:"Navigate Your Book", front:"Front Matter", back:"Back Matter",
       unassigned:"Unassigned Pages & Spreads", note:"Navigation only: no chapters or scenes are created automatically.",
       invalid:"Chapter organization is invalid; pages are shown without grouping."};
  if (!model.ok && model.code === "invalid_unit_identity") {
    return <section role="status" data-testid="cb-chapter-scene-nav-invalid">
      {isFR ? "Impossible de parcourir les pages : identifiants non uniques." : "Cannot navigate pages: missing or duplicate page identities."}
    </section>;
  }
  const unitButton = (item) => (
    <button key={item.unitId} type="button" className="ns-button ns-button-outline"
      data-testid="cb-navigate-existing-unit" data-unit-id={item.unitId}
      onClick={() => onOpenUnit?.(item.unitId)}
      style={{textAlign:"left", minHeight:38}}>
      {item.pageLabel}{item.title ? " · " + item.title : ""}
    </button>
  );
  return (
    <nav aria-label={labels.title} data-testid="cb-chapter-scene-nav-v1"
      className="ns-card" style={{padding:16, borderRadius:16, marginBottom:18}}>
      <h3 style={{margin:"0 0 6px"}}>{labels.title}</h3>
      <p className="ns-card-meta" style={{margin:"0 0 12px"}}>{labels.note}</p>
      {!model.ok ? <p role="status">{labels.invalid}</p> : null}
      <div style={{display:"grid",gap:14}}>
        {model.sections.map(section => (
          <section key={section.key} data-testid={"cb-outline-" + section.kind}>
            <h4 style={{margin:"0 0 8px"}}>
              {section.kind === "chapter" ? section.title : labels[section.kind]}
            </h4>
            {section.kind === "chapter" ? (
              <div style={{display:"grid",gap:10}}>
                {section.scenes.map(scene => (
                  <div key={scene.key}>
                    <strong>{scene.title}</strong>
                    <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:6}}>
                      {scene.entries.map(unitButton)}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {section.entries.map(unitButton)}
              </div>
            )}
          </section>
        ))}
      </div>
    </nav>
  );
}
